// extracted by mini-css-extract-plugin
export var icon = "_bf-3";
export var subtitle = "_bf-2";
export var title = "_bf-1";
export var value = "_bf-0";